import { ITongHopToanKhoaActionTypes } from "../../action-types/tong-hop-diem/ITongHopToanKhoaActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ITongHopToanKhoaReducer } from "../../reducer-model/tong-hop-diem/ITongHopToanKhoaReducer";

const iniState: ITongHopToanKhoaReducer = {
    status: eReducerStatusBase.is_not_initialization,
    tongHopDiem: {
        chuongtrinhdaotaochitietlist: [],
        ketquatonghop: [],
    },
    isShowDiemThanhPhan: false,
    isShowCacLanDiem: false
}

export const tongHopToanKhoaReducer = (state: ITongHopToanKhoaReducer = iniState, action: ITongHopToanKhoaActionTypes): ITongHopToanKhoaReducer => {
    switch (action.type) {
        case "TONG_HOP_TOAN_KHOA_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "TONG_HOP_TOAN_KHOA_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                tongHopDiem: action.payload,
            };
        case "TONG_HOP_TOAN_KHOA_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "TONG_HOP_TOAN_KHOA_CHANGE_IS_SHOW_DIEM_THANH_PHAN":
            return {
                ...state,
                isShowDiemThanhPhan: action.payload,
                isShowCacLanDiem: false,
            };
        case "TONG_HOP_TOAN_KHOA_CHANGE_IS_SHOW_CAC_LAN_DIEM":
            return {
                ...state,
                isShowCacLanDiem: action.payload,
                isShowDiemThanhPhan: false,
            };
        case "TONG_HOP_TOAN_KHOA_CHANGED_FOCUSED_VALUE_LOP":
            return {
                ...state,
                focusedValueLop: action.payload,
                tongHopDiem: {
                    ...state.tongHopDiem,
                    chuongtrinhdaotaochitietlist: [],
                    ketquatonghop: []
                }
            };
        default:
            return state;
    }
}